const ClassNames = (...names) => names.join(' ')

export default ClassNames
